import React from 'react'
import { Controller } from 'react-hook-form'
import { KeyboardDatePicker } from '@material-ui/pickers'
import classes from './Form.module.sass'

export function DatePicker({ control, register, name, label, className, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <label className={`${classes.label} ${className}`}>
          {label}
          <KeyboardDatePicker
            placeholder="Select date"
            className={classes.keyboardDatePicker}
            autoOk
            disableToolbar
            variant="inline"
            format="MM/dd/yyyy"
            margin="dense"
            value={value}
            onChange={onChange}
            {...rest}
          />
        </label>
      )}
    />
  )
}
